import { render } from "./TipoCaps.vue?vue&type=template&id=1102b2d9"
import script from "./TipoCaps.vue?vue&type=script&lang=js"
export * from "./TipoCaps.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__